<form [formGroup]="data.fg">
  <mat-form-field class="user-milestone-name">
    <mat-label>Project Date Name</mat-label>
    <label>
      <input
        matInput
        type="text"
        formControlName="name"
        [readonly]="readOnly"
        [ngClass]="{ 'milestone-entry-changed': isDirty('name') }"
      />
    </label>
    <mat-error>Please enter a name for this Milestone</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Date</mat-label>
    <label>
      <input
        matInput
        type="date"
        formControlName="date"
        [readonly]="readOnly"
        [ngClass]="{ 'milestone-entry-changed': isDirty('date') }"
      />
    </label>
    <mat-error *ngIf="this.data.fg.get('date').invalid">
      {{ ValidatorUtil.getErrorMessage(this.data.fg.get('date')) }}
    </mat-error>
  </mat-form-field>

  <digires-checkbox
    [formGroup]="data.fg"
    formCtrlName="done"
    [disabled]="readOnly"
    tooltip="Completed"
    [cssClasses]="{ 'milestone-entry-changed': isDirty('done') }"
  ></digires-checkbox>

  <button mat-icon-button type="button" (click)="onDelete.emit()">
    <mat-icon>delete</mat-icon>
  </button>
</form>
